/**
 * 0.44.67 - Dates from libraries and collections formatted for the page.
 * 0.44.69 - In the public site's format from Settings > Time & date (the
 * admin panel's on admin pages), never the browser's locale.
 *
 * Library and collection rows carry dates as stored ('YYYY-MM-DD',
 * 'YYYY-MM-DDTHH:MM', 'HH:MM'); the server says which columns hold them
 * (column_types). Wall-clock values: no time zone shifts the day. The
 * stored value stays available as <column>_iso for rules that compare
 * or calculate with dates.
 */
import { formatCalendarDate, formatCalendarDateTime, formatClockTime } from '../utils/format';

/* 0.44.69 - Always the site's own format (Settings > Time & date,
 * public site column), never the browser's: a browser's locale tells
 * American from British English only by guesswork, and many visitors
 * read the site in Armenian on an English-language browser. */
export function formatForVisitor(value, kind) {
  const s = String(value == null ? '' : value).trim();
  if (!s) return '';
  if (kind === 'date') return formatCalendarDate(s);
  if (kind === 'datetime') return formatCalendarDateTime(s);
  if (kind === 'time') return formatClockTime(s);
  return s;
}

/** A row with its date columns in the visitor's format; the stored
 *  values kept as <column>_iso (unless the row already has one). */
export function localizeRow(row, types) {
  if (!row || typeof row !== 'object' || !types) return row;
  const keys = Object.keys(types);
  if (!keys.length) return row;
  const out = { ...row };
  for (const k of keys) {
    const v = row[k];
    if (typeof v !== 'string' || !v) continue;
    if (out[`${k}_iso`] === undefined) out[`${k}_iso`] = v;
    out[k] = formatForVisitor(v, types[k]);
  }
  return out;
}

export function localizeRows(rows, types) {
  if (!Array.isArray(rows) || !types || !Object.keys(types).length) return rows;
  return rows.map(r => localizeRow(r, types));
}
